export default "__VITE_ASSET__CrLN1B7B__"